import { Dispatch } from "react";
import { MainBorrowerPricingAction, MainBorrowerPricingAsyncActions } from "../actions/types";

const DEBOUNCE_DELAY = 600;
const funnelFeeUpdateTimeouts = new Map<string, ReturnType<typeof setTimeout>>();

export const createMainBorrowerPricingMiddleware = (
  asyncActions: MainBorrowerPricingAsyncActions
) => {
  return (next: Dispatch<MainBorrowerPricingAction>) => (action: MainBorrowerPricingAction) => {
    // Appeler d'abord le reducer pour mettre à jour l'état
    next(action);

    if (process.env.NODE_ENV === 'development') {
      // console.log(action);
    }

    if (action.type === 'INIT_PRICING_PROCESS') {
      asyncActions.fetchShoppingCart(action.payload.borrowerProjectId, action.payload.borrowerId);
    }

    // Debounce individual contract funnel fee updates
    if (action.type === 'UPDATE_CONTRACT_FUNNEL_FEE') {
      const { contractFunnelId, contractIdentifier, funnelHash } = action.payload;
      // Utiliser le hash comme clé unique (deux funnels de groupe peuvent avoir le même id+contractIdentifier)
      const key = funnelHash;

      const existingTimeout = funnelFeeUpdateTimeouts.get(key);
      if (existingTimeout) {
        clearTimeout(existingTimeout);
      }

      const timeout = setTimeout(() => {
        funnelFeeUpdateTimeouts.delete(key);
        asyncActions.onContractFunnelFeeUpdate(contractFunnelId, contractIdentifier, funnelHash);
      }, DEBOUNCE_DELAY);

      funnelFeeUpdateTimeouts.set(key, timeout);
    }

    // Quand les fees globaux changent, appeler un seul custom-global avec les funnels non-édités
    if (action.type === 'SYNC_GLOBAL_FEES_TO_FUNNELS') {
      const globalFees = action.payload.fees;

      // Annuler tous les debounce individuels en cours
      const existingSyncTimeout = funnelFeeUpdateTimeouts.get('__sync_global__');
      if (existingSyncTimeout) {
        clearTimeout(existingSyncTimeout);
      }

      const timeout = setTimeout(() => {
        funnelFeeUpdateTimeouts.delete('__sync_global__');
        asyncActions.onAdjustments({ globalFees });
      }, DEBOUNCE_DELAY);

      funnelFeeUpdateTimeouts.set('__sync_global__', timeout);
    }

    return action;
  };
};
